<div class="toasts-container">
  <evc-info-banner
    *ngFor="let toast of toastService.toasts$ | async; trackBy: trackBy"
    [style]="'neutral'"
    [@fade]
    [icon]="iconName(toast)"
    [action]="closeAction(toast)"
  >
    <div banner-content>
      {{ toast.message | translate }}
    </div>
  </evc-info-banner>
</div>
